export default __webpack_public_path__ + "static/media/logo.560860c9.png";